"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-vito-chietino": {
    "a6595481": [{
      "hkey": "245738cf",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito-capoluogo": [{
      "hkey": "245738cf",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91135da8": [{
      "hkey": "91d3ffe4",
      "slug": "marina-di-san-vito",
      "name": "Marina di San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito-marina": [{
      "hkey": "91d3ffe4",
      "slug": "marina-di-san-vito",
      "name": "Marina di San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;